import { render, staticRenderFns } from "./PageBreadcrumbs.vue?vue&type=template&id=019390f2&scoped=true&"
import script from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./PageBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./PageBreadcrumbs.vue?vue&type=style&index=0&id=019390f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019390f2",
  null
  
)

export default component.exports